import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";


export function hostArrivedPackValidator(): ValidatorFn{
    return (control: AbstractControl): ValidationErrors | null => {
        const value = control.value;
        if( value < 0.5){
            return {'numberNotGreaterThanZero': true}
        }
        return null;
    } 
}